import React from 'react';
import createReactClass from 'create-react-class';

/* eslint-disable max-len */
const URLS = {
  preppingForUpload: 'https://articles.fortawesome.com/prepping-icons-with-pathfinder-4452f6ba2e37',
  advancedIconDesign: 'https://articles.fortawesome.com/advanced-icon-design-whitespace-bdd63e6cde3b',
  visualConsistency: 'https://articles.fortawesome.com/creating-an-awesome-icon-set-part-1-visual-consistency-and-setup-ec325b1d443f',
  sixTipsForIcons: 'https://articles.fortawesome.com/creating-an-awesome-icon-set-part-2-6-tips-for-designing-crisp-readable-icons-78339363eb80',
};
/* eslint-enable max-len */

export default createReactClass({
  render() {
    return (
      <div className="alert alert-primary bg-body text-sm m-xs-y-md">
        <h3 className="text-base">Help Uploading Icons</h3>
        <hr className="m-xs-t-sm m-xs-b-md" />

        <h4 className="text-sm">Getting Started with Fort Awesome</h4>
        <ul className="m-xs-b-lg p-xs-l-md">
          <li><a href={URLS.preppingForUpload}>Prepping Icons for Upload</a></li>
          <li><a href={URLS.advancedIconDesign}>Advanced Icon Design: Whitespace</a></li>
        </ul>

        <h4 className="text-sm">Build an Awesome Icon Set</h4>
        <ul className="p-xs-l-md">
          <li><a href={URLS.visualConsistency}>Visual Consistency and Setup</a></li>
          <li><a href={URLS.sixTipsForIcons}>6 Tips for Designing Crisp, Readable Icons</a></li>
        </ul>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/HelpUploadingIcons.js